import {addWishlistItemTemplateURL} from "../../common/others/Configuration";
import rejectNonOkResponse from "../rejectNonOkResponse";

export default (wishlistPublicId, prid, catalog, offerReference = "") => rejectNonOkResponse(fetch(
  addWishlistItemTemplateURL({wishlistPublicId, prid, catalog, offerReference}),
  {
    method: 'PUT',
    credentials: "include"
  }
)).then(() => true);



